import orderBy from 'lodash/orderBy';
import { checkTokenExpiration } from '../utils/checkTokenExpiration';
import { getCurrentSession } from '../../lib/authentication';

export const fetchAll = () => {
    return getCurrentSession()
        .then(result => {
            const { idToken } = result;
            return apigClient.brokeragesGet(
                {},
                {},
                {
                    headers: { Authorization: idToken }
                }
            );
        })
        .then(response => orderBy(response.data.data.Items, ['name'], ['asc']));
};

export const updateBrokerage = (id, broker, user) => {
    return Promise.all([checkTokenExpiration(user), getCurrentSession()]).then(results => {
        const [expirationToken, currentSession] = results;
        let { idToken } = currentSession;
        return apigClient.brokeragesPut({ id: id }, broker, {
            headers: { Authorization: idToken }
        });
    });
};
